import React from "react";
import Avatar from "../Avatar";
import styled from "styled-components";
import { convertTimeIntoHourMin } from "../utils/generic";

const LocationMessageUI = styled.div`
  min-width: 230px;
  .location-map {
    margin: -14px;
  }
  .location-name {
    // font-family: Plus Jakarta Sans;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
    color: #28a6de;
  }
  .location-add {
    max-width: 188px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    margin-bottom: 0px;
    margin-left: 30px;
  }
`;

export default function Location({ message }) {
  const latitude = message.content.latitude;
  const longitude = message.content.longitude;
  return (
    <LocationMessageUI>
      <div className="location-map">
        {/* <iframe
          // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.731155568297!2d72.52182397456563!3d23.033641379165996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84454bffdb4f%3A0x7e7b3b1942540420!2sAbhishree%20Adroit!5e0!3m2!1sen!2sin!4v1717068277010!5m2!1sen!2sin"
          src={`https://www.openstreetmap.org/export/embed.html?bbox=${longitude -
            0.05},${latitude - 0.05},${longitude + 0.05},${latitude +
            0.05}&layer=mapnik&marker=${latitude},${longitude}`}
          width="260"
          height="170"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe> */}

        <a
          href={`https://www.google.com/maps?q=${latitude},${longitude}&hl=es;z=14`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <iframe
            src={`https://www.openstreetmap.org/export/embed.html?bbox=${longitude -
              0.05},${latitude - 0.05},${longitude + 0.05},${latitude +
              0.05}&layer=mapnik&marker=${latitude},${longitude}`}
            width="260"
            height="170"
            style={{ border: 0, borderRadius: '14px 14px 0px 0px' }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </a>
      </div>
      <div>
        <a
          href={`https://maps.google.com/maps?q=${message.content.latitude},${message.content.longitude}&hl=es;z=14&amp;output=embed`}
          target="_blank"
          className="d-flex align-items-center pt-5 pb-3"
        >
          <span
            class="material-symbols-outlined mr-2"
            style={{ fontSize: "26px", color: "#28A6DE" }}
          >
            location_on
          </span>
          <div className="location-name">{message.content.addressName}</div>
        </a>
      </div>
      <div>
        <p className="location-add">{message.content.address}</p>
      </div>

      {/* <div className="message-info-td">
        <span className="message-time">{convertTimeIntoHourMin(message.timeStamp)}</span>
        <span className="material-symbols-outlined message-deliver">done_all</span>
      </div> */}
    </LocationMessageUI>
  );
}



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/AssistComponents/Location.js